import { css } from '@linaria/core';

export const shortenedUrlWiggleStyles = css`
  @keyframes wiggle {
    0%,
    100% {
      transform: translateX(var(--fabric-number-n-0));
    }
    20% {
      transform: translateX(var(--fabric-number-n-2-neg));
    }
    50% {
      transform: translateX(var(--fabric-number-n-2));
    }
    80% {
      transform: translateX(var(--fabric-number-n-1-neg));
    }
  }

  animation: wiggle 400ms ease-in-out;
`;

export const modalBodyStyles = css`
  margin: var(--fabric-space-padding-none);
  padding: var(--fabric-space-padding-none);
`;

export const templateSelectionContainerStyles = css`
  border-radius: var(--fabric-radius-md);
  border: var(--fabric-number-n-0-25) solid var(--fabric-color-neutral-20);
  margin-top: var(--fabric-space-padding-md);
  overflow-y: hidden;
`;

export const templateSelectionHeaderStyles = css`
  display: flex;
  align-items: center;
  padding: var(--fabric-space-padding-md) var(--fabric-space-padding-xs);
  gap: var(--fabric-space-gap-md);
  border-bottom: var(--fabric-number-n-0-25) solid var(--fabric-color-neutral-20);
`;

export const templateSelectorStyles = css`
  padding: var(--fabric-space-padding-md);
  height: calc(100% - var(--fabric-space-padding-xl));
  overflow-y: hidden;
`;

export const sendInThreadViewStyles = css`
  display: flex;
  flex-direction: column;
  border-radius: var(--fabric-radius-md);
  border: var(--fabric-number-n-0-25) solid var(--fabric-color-neutral-20);
`;

export const bodyAndSendAreaContainerStyles = css`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const footerContentStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const footerActionsStyles = css`
  display: flex;
  align-items: center;
  gap: var(--fabric-space-gap-md);
`;

export const inlineNotificationBorderNoneStyles = css`
  border: none;
`;

export const dialogPopoverStyles = css`
  padding: var(--fabric-space-padding-xs) var(--fabric-space-padding-none);
  border-radius: var(--fabric-radius-sm);
`;

export const sendButtonStyles = css`
  white-space: nowrap;
`;

export const sendButtonCaretOverrideStyles = css`
  width: auto;
  padding: var(--fabric-space-gap-xs);
  box-shadow: inset 1px 0 0 0 var(--fabric-color-action-primary-background-pressed);
`;

export const tooltipCenteredStyles = css`
  text-align: center;
`;

export const modalFlexContent = css`
  display: flex;
  flex-direction: column;
  gap: var(--fabric-number-n-8);
  height: 100%;
`;

export const modalFlexContentSmall = css`
  gap: var(--fabric-number-n-6);
`;

export const modalBodyFlexContent = css`
  display: flex;
  flex-direction: column;
  gap: var(--fabric-number-n-4-rem);
  height: 100%;
`;

export const footerContainerStyles = css`
  &.wv-modal-footer {
    padding: var(--fabric-space-padding-none);
  }
`;

export const headerContainerStyles = css`
  padding: var(--fabric-space-padding-none);
`;

export const modalHeaderStyles = css`
  padding: var(--fabric-space-padding-none);
  line-height: var(--fabric-number-n-8-rem);

  /* Override the responsive modal's mobile .wv-modal-header padding (higher specificity) */
  &&.wv-modal-header {
    padding: var(--fabric-space-padding-none);
  }
`;

export const modalHeaderStylesSmall = css`
  && h2 {
    font-size: var(--fabric-number-n-5);
  }
`;

export const styles = {
  shortenedUrlWiggleStyles,
  modalBodyStyles,
  modalHeaderStyles,
  modalHeaderStylesSmall,
  templateSelectionContainerStyles,
  templateSelectionHeaderStyles,
  templateSelectorStyles,
  sendInThreadViewStyles,
  bodyAndSendAreaContainerStyles,
  footerContentStyles,
  footerActionsStyles,
  inlineNotificationBorderNoneStyles,
  dialogPopoverStyles,
  sendButtonStyles,
  tooltipCenteredStyles,
  sendButtonCaretOverrideStyles,
  modalFlexContent,
  modalFlexContentSmall,
  modalBodyFlexContent,
  footerContainerStyles,
  headerContainerStyles,
};
